import React from 'react';
import { Outlet } from 'react-router-dom';
import { AppSettings } from '../../config/app-settings.js';
import { useContext } from 'react';

function Content() {

	const context = useContext(AppSettings);
	const appHeaderNone = context.appHeaderNone;

	return (
		<AppSettings.Consumer>
			{({appContentClass}) => (
				<div className={`app-content ${appHeaderNone ? ' app-header-none' : ''} ${appContentClass}`}>
					<Outlet />
				</div>
			)
		}
		</AppSettings.Consumer>
	)
}

export default Content;
